<template>
  <div class="container">
    <div class="d-flex py-0 my-0">
      <!--Caso es Imagen Normal-->
      <div v-if="isModal === false">
        <div class="d-flex justify-content-end m-2">
          <b-dropdown
            id="dropdown-1"
            size="sm"
            right
            variant="info"
            :class="{ ocultarClass: esHome }"
            text="Editar"
            class="btn-elemento btn-options"
          >
            <b-dropdown-item
              @click="subirImg == true ? (subirImg = false) : (subirImg = true)"
            >Subir imagen</b-dropdown-item>
            <div v-if="!isTrivia">
              <!--Checa si la imagen será un Modal, de ser asi no se muestran estas opciones-->
              <b-dropdown-item
                @click="
                  showSize == true ? (showSize = false) : (showSize = true)
                "
              >Ajustar tamaño</b-dropdown-item>

              <b-dropdown-item
                @click="
                  showAnimation == true
                    ? (showAnimation = false)
                    : (showAnimation = true)
                "
              >Agregar animación</b-dropdown-item>
              <b-dropdown-item
                @click="
                  showMargin == true
                    ? (showMargin = false)
                    : (showMargin = true)
                "
              >Agregar margen</b-dropdown-item>
              <b-dropdown-item
                @click="
                  showPosicion == true
                    ? (showPosicion = false)
                    : (showPosicion = true)
                "
              >Posición</b-dropdown-item>
            </div>
          </b-dropdown>
        </div>
      </div>
      <!--NOTE Caso es Imagen Modal-->
      <div v-else>
        <div>
          <b-form-file
            size="sm"
            accept="image/*"
            browse-text="Abrir"
            placeholder="Imagen"
            :file-name-formatter="getName"
            class="mb-2"
          ></b-form-file>
        </div>
      </div>
    </div>

    <!--NOTE menu margen-->
    <div v-show="showMargin" class="row">
      <div class="col-8 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar Márgenes</p>
        </div>

        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div style="overflow:hidden ">
              <label for="left">Margen izquierdo</label>
              <input
                v-model.number="localMargin['ml']"
                type="number"
                min="0"
                max="8"
                name="left"
                id
              />
            </div>

            <div style="overflow:hidden ">
              <label for="top">Margen superior</label>
              <input v-model.number="localMargin['mt']" type="number" min="0" max="8" name="top" id />
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <label for="right">Margen derecho</label>
              <input
                v-model.number="localMargin['mr']"
                type="number"
                min="0"
                max="8"
                name="right"
                id
              />
            </div>
            <div style="overflow:hidden">
              <label for="bottom">Margen inferior</label>
              <input v-model.number="localMargin['mb']" type="number" min="0" max="8" name="bottom" />
            </div>
          </div>
        </div>
        <div class="col">
          <div @click="addMargin" class="btn btn-primary m-2">Aplicar</div>

          <div
            @click="
              showMargin == true ? (showMargin = false) : (showMargin = true)
            "
            class="btn btn-danger m-2"
          >Cerrar</div>
        </div>
      </div>
    </div>

    <div v-show="showAnimation" class="row">
      <div class="col-6 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h5">Agregar animacion</p>
        </div>
        <div class="p-3">
          <div class="d-flex flex-row justify-content-around">
            <div
              @click="addAnimation('fade')"
              class="btn btn-primary py-2 px-2 animation-fade"
            >FadeIn</div>
            <div style="overflow:hidden ">
              <div
                @click="addAnimation('bounce')"
                class="btn btn-warning py-2 px-2 animation-bounce"
              >Bounce</div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-around my-2">
            <div style="overflow:hidden">
              <div
                @click="addAnimation('lr')"
                class="btn btn-primary py-2 px-2 animation-slide-l-r"
              >Slide in</div>
            </div>
            <div style="overflow:hidden">
              <div
                @click="addAnimation('rl')"
                class="btn btn-warning py-2 px-2 animation-slide-r-l"
              >Slide in</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button size="sm" v-on:click="saveAnimation()" variant="success">Guardar</b-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showPosicion" class="row pb-2">
      <div class="col-6 px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Posicionar</p>
        </div>
        <div class="p-3">
          <b-button-group size="sm" class="d-flex flex-row justify-content-center">
            <b-button @click="changePosition('left')" class="mx-4" active variant="outline-success">
              <img src="@/assets/f-left.svg" alt />
            </b-button>
            <b-button @click="changePosition('center')" class="mx-4" variant="outline-info">
              <img src="@/assets/f-center.svg" alt />
            </b-button>
            <b-button @click="changePosition('right')" class="mx-4" variant="outline-warning">
              <img src="@/assets/f-right.svg" alt />
            </b-button>
          </b-button-group>
        </div>
        <div class="d-flex justify-content-end">
          <b-button size="sm" v-on:click="showPosicion = false" variant="success">Guardar</b-button>
        </div>
      </div>
    </div>
    <!--Menu cambiar tamaño de la img-->
    <div v-show="showSize" class="pb-2 options">
      <div class="px-0 mx-0 posicionar-container">
        <div class="posicionar-titulo p-2 pl-3">
          <p class="h3">Tamaño de la imagen</p>
        </div>
        <b-button-toolbar class="m-1">
          <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 30">Chico</b-button>
          <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 50">Mediano</b-button>
          <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 75">Grande</b-button>
          <b-button class="mx-1" size="sm" variant="info" v-on:click="imgSize = 100">100%</b-button>
        </b-button-toolbar>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            v-on:click=";(showSize = false), saveSize(imgSize)"
            variant="success"
          >Guardar</b-button>
        </div>
      </div>
    </div>

    <div v-show="subirImg">
      <div class="p-1 posicionar-container">
        <div>
          <b-form-file
            size="sm"
            accept="image/*"
            browse-text="Abrir"
            placeholder="Imagen"
            :file-name-formatter="getName"
            class="mb-2"
          ></b-form-file>
        </div>
        <div class="d-flex justify-content-end">
          <b-button size="sm" v-on:click="subirImg = false" variant="success">Guardar</b-button>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div ref="imgcontainer" class="col-12 d-flex flex-row justify-content-center">
        <img
          ref="imgref"
          v-bind:src="img"
          :style="'width: ' + imgSize + '%;'"
          class="img-element img-fluid"
          alt="Imagen"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import img from '@/assets/logo.png'
import firebase from 'firebase'

export default {
  name: 'Imagen',
  props: {
    isModal: Boolean,
    isTrivia: Boolean,
    data: Object,
    idSection: String,
    subid: Number,
    route: Object,
    idQuestion: Number,
    idPop: Number,
    isPop: Boolean,
    esHome: Boolean,
    online: Boolean,
    elementid: Number
  },
  data() {
    return {
      img: '',
      imgLocation: '',
      subirImg: false,
      showPosicion: false,
      showAnimation: false,
      showSize: false,
      showMargin: false,
      localRoot: '',
      animation: '',
      position: '',
      imgSize: 30,
      isElem: true,
      ruta: [],
      firebaseURL: '',
      localMargin: {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      },
      localPadding: {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
    }
  },

  created() {
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    //si la imagen viene desde la portada
    if (this.route != null) {
      this.img = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['src'][0]['url']

      //si esta conectado a internet la src de la img cambia
      if (this.online) {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'src'
        ][0]['url']
      } else {
        this.img =
          'imgs/' +
          this.localRoot['componentes'][this.route.name][this.route.index][
            'src'
          ][0]['name']
      }
      this.imgSize = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['size']
      this.position = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['position']
      this.animation = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['animation']
      this.localMargin = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['margin']
      this.localPadding = this.localRoot['componentes'][this.route.name][
        this.route.index
      ]['padding']
      this.isElem = false
    } else {
      //Si la imagen viene desde un elemento de una sección
      this.isElem = true
      //Si la imagen viene desde una preguntna de la trivia
      if (this.isTrivia) {
        console.log(
          'kepasa',
          this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid].extras[this.idQuestion][
            'src'
          ][0]['name']
        )

        //si esta conectado a internet la src de la img cambia
        if (this.online) {
          this.img = this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid].extras[this.idQuestion][
            'src'
          ][0]['url']
          // console.log('trivia img: ' + this.img + '\n')
        } else {
          this.img =
            'imgs/' +
            this.localRoot['componentes']['secciones'][this.idSection][
              'subsecciones'
            ][this.subid]['elements'][this.elementid].extras[this.idQuestion][
              'src'
            ][0]['name']
        }
        this.imgSize = 100
      } else if (this.isPop) {
        //si la imagen viene desde un PopUp Modal
        //si esta conectado a internet la src de la img cambia
        if (this.online) {
          this.img = this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid].extras[this.idPop]['url']
        } else {
          this.img =
            'imgs/' +
            this.localRoot['componentes']['secciones'][this.idSection][
              'subsecciones'
            ][this.subid]['elements'][this.elementid].extras[this.idPop]['name']
        }
      } else {
        //si la imagen viene desde un elemento Imagen normal
        this.animation = this.localRoot['componentes']['secciones'][
          this.idSection
        ]['subsecciones'][this.subid].animation
        this.localMargin = this.localRoot['componentes']['secciones'][
          this.idSection
        ]['subsecciones'][this.subid]['elements'][this.elementid]['margin']
        this.localPadding = this.localRoot['componentes']['secciones'][
          this.idSection
        ]['subsecciones'][this.subid]['elements'][this.elementid]['padding']

        //si esta conectado a internet la src de la img cambia
        if (this.online) {
          this.img = this.localRoot['componentes']['secciones'][this.idSection][
            'subsecciones'
          ][this.subid]['elements'][this.elementid]['src'][0].url
          // this.img = this.localRoot['componentes']['secciones'][this.idSection]['subsecciones'][this.subid]['src'][0]['url']
        } else {
          this.img =
            'imgs/' +
            this.localRoot['componentes']['secciones'][this.idSection][
              'subsecciones'
            ][this.subid]['elements'][this.elementid]['src'][0]['name']
        }
        this.position = this.localRoot['componentes']['secciones'][
          this.idSection
        ]['subsecciones'][this.subid]['elements'][this.elementid]['position']
        this.imgSize = this.localRoot['componentes']['secciones'][
          this.idSection
        ]['subsecciones'][this.subid]['elements'][this.elementid]['size']
      }
    }

    // console.log('La img es: ' + this.img)
  },

  mounted() {
    this.addAnimation(this.animation)
    this.changePosition(this.position)
    this.addMargin()
  },

  methods: {
    addMargin() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      let textElementMargin = this.$refs.imgref
      if (!textElementMargin) {
        return
      }
      textElementMargin.className = ''

      textElementMargin.classList.add('img-element', 'img-fluid')

      textElementMargin.classList.add(
        'pt-' + this.localPadding['pt'],
        'mt-' + this.localMargin['mt']
      )
      textElementMargin.classList.add(
        'pr-' + this.localPadding['pr'],
        'mr-' + this.localMargin['mr']
      )
      textElementMargin.classList.add(
        'pb-' + this.localPadding['pb'],
        'mb-' + this.localMargin['mb']
      )
      textElementMargin.classList.add(
        'pl-' + this.localPadding['pl'],
        'ml-' + this.localMargin['ml']
      )

      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['margin'] = this.localMargin

        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['padding'] = this.localPadding
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'margin'
        ] = this.localMargin
        this.localRoot['componentes'][this.route.name][this.route.index][
          'padding'
        ] = this.localMargin
      }

      window.localStorage.setItem('root', JSON.stringify(this.localRoot))
    },

    getName(file) {
      if (file.length === 1) {
        let locationStorage = '/imagenes/'
        let storageRef = firebase.storage().ref(locationStorage + file[0].name)
        let uploadTask = storageRef.put(file[0])

        uploadTask.on(
          'state_changed',
          snapshot => {
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                console.log('Upload is paused')
                break
              case firebase.storage.TaskState.RUNNING:
                console.log('Upload is running')
                break
            }
          },
          error => {
            console.log(error)
          },
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.firebaseURL = downloadURL
              this.$emit('setted', this.firebaseURL)
              this.localRoot = JSON.parse(window.localStorage.getItem('root'))
              if (this.isElem && !this.isTrivia) {
                if (this.isPop) {
                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid].extras[this.idPop][
                    'url'
                  ] = this.firebaseURL
                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid].extras[this.idPop][
                    'name'
                  ] = file[0].name
                  console.log('espop', file[0].name)
                } else {
                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid]['src'][0][
                    'url'
                  ] = this.firebaseURL
                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid]['src'][0]['name'] =
                    file[0].name
                  console.log('imgmodal', file[0].name)
                }
              } else {
                if (this.isTrivia) {
                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid].extras[
                    this.idQuestion
                  ]['src'][0]['url'] = this.firebaseURL

                  this.localRoot['componentes']['secciones'][this.idSection][
                    'subsecciones'
                  ][this.subid]['elements'][this.elementid].extras[
                    this.idQuestion
                  ]['src'][0]['name'] = file[0].name
                  console.log('trivia', file[0].name)
                } else {
                  this.localRoot['componentes'][this.route.name][
                    this.route.index
                  ]['src'][0]['url'] = this.firebaseURL
                  this.localRoot['componentes'][this.route.name][
                    this.route.index
                  ]['src'][0]['name'] = file[0].name
                  console.log('imgnormal', file[0].name)
                }
              }

              let parsedRoot = JSON.stringify(this.localRoot)
              window.localStorage.setItem('root', parsedRoot)
              alert('La imagen se ha subido!')
              // Obtengo el elemento DOM de la imagen
              let imgitem = this.$refs.imgref

              //Checo si estoy online u offline
              if (this.online) {
                imgitem.src = this.firebaseURL
                this.img = this.firebaseURL
                this.$emit('setted', this.img)
              } else {
                imgitem.src = 'imgs/' + file[0].name
                this.img = imgitem.src
                this.$emit('setted', this.img)
              }
            })
          }
        )

        // var fileName = file.target.files[0].name;
        // alert(file[0].name)

        // this.img = 'imgs/' + file[0].name
        // let reader = new FileReader()
        // reader.onload = () => {

        //   let dataURL = reader.result
        //   this.img = dataURL
        //   this.$emit('setted', this.img)
        //   // this.url = dataURL
        // }
        // reader.readAsDataURL(file[0])
      } else {
        return alert('Solo se puede subir una imagen')
      }
    },
    changePosition(value) {
      this.position = ''
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      switch (value) {
        case 'left':
          this.$refs.imgcontainer.classList.remove('justify-content-end')
          this.$refs.imgcontainer.classList.remove('justify-content-center')
          this.$refs.imgcontainer.classList.add('justify-content-start')
          this.position = 'left'
          break
        case 'center':
          this.$refs.imgcontainer.classList.remove('justify-content-start')
          this.$refs.imgcontainer.classList.remove('justify-content-end')
          this.$refs.imgcontainer.classList.add('justify-content-center')
          this.position = 'center'
          break
        case 'right':
          this.$refs.imgcontainer.classList.remove('justify-content-start')
          this.$refs.imgcontainer.classList.remove('justify-content-center')
          this.$refs.imgcontainer.classList.add('justify-content-end')
          this.position = 'right'
          break

        default:
          break
      }
      //Se guarda la posición del elemento en root
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['position'] = this.position
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'position'
        ] = this.position
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    addAnimation(type) {
      this.animation = ''
      switch (type) {
        case 'rl':
          this.animation = 'rl'
          break

        case 'lr':
          this.animation = 'lr'
          break

        case 'bounce':
          this.animation = 'bounce'
          break

        case 'fade':
          this.animation = 'fade'
          break

        default:
          break
      }
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        //console.log("algo")
        this.localRoot['componentes']['secciones'][this.idSection].subsecciones[
          this.subid
        ]['elements'][this.elementid]['animation'] = this.animation
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'animation'
        ] = this.animation
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    saveSize(size) {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      if (this.isElem) {
        this.localRoot['componentes']['secciones'][this.idSection][
          'subsecciones'
        ][this.subid]['elements'][this.elementid]['size'] = size
      } else {
        this.localRoot['componentes'][this.route.name][this.route.index][
          'size'
        ] = size
      }
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    saveAnimation() {
      // console.log(this.animation)
      this.showAnimation = false
    },
    savePosition() {
      // console.log(this.position)
      this.showPosicion = false
      // this.localFooter.animation = this.psoition
      // let parsedRoot = JSON.stringify(this.localRoot)
      // window.localStorage.setItem('root', parsedRoot)
    }
  }
}
</script>

<style scoped>
.btn-elemento {
  position: absolute;
  top: -20px;
  right: 0;
  margin: 5px;
}

.img-element {
  /*height: 200px;
  width: 400px;*/
  position: relative;
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}
.base-animation {
  opacity: 1;
}
.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 3s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 2s;
  animation-play-state: running;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}
@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}
</style>
